import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IItemTagState } from './item-tag.types';
import { ITagData } from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IItemTagState = {
  version: 1,
  tags: [] as ITagData[],
  lastPromise: null
};

const namespaced = true;

export const itemTag: Module<IItemTagState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
